export default "__VITE_ASSET__7ed658d3__"